// extracted by mini-css-extract-plugin
export default {"indicator":"outage-info_indicator__p0l-3"};